import React, { createContext, useEffect, useState } from "react";

export const GVarState = createContext();
function Gstate({ children }) {
  const [width, setwidth] = useState(100)
  const [height, setheight] = useState(100)
  const [nodePoint, setnodePoint] = useState(null)
  const [nodeLine, setnodeLine] = useState(null)
  const [CurrentFloor, setCurrentFloor] = useState(false)
  const [FloorImg, setFloorImg] = useState(undefined)
  const [finleSearch, setfinleSearch] = useState(false)
  const [selectPointA, setselectPointA] = useState(undefined)
  const [selectPointB, setselectPointB] = useState(undefined)
  const [PointType, setPointType] = useState({ elevator: false, escalator: false, stair: false })
  const [viewType, setViewType] = useState("");
  const [mallType, setMallType] = useState("");
  const [StapeByStape, setStapeByStape] = useState(null);
  const [path, setpath] = useState([]);
  const [w, setw] = useState(10);
  const [h, seth] = useState(10);
  const [StartSearchInput, setStartSearchInput] = useState(null) // start point select hota hai jaha se aap ko jana hai {name:"",point:""}
  const [EndSearchInput, setEndSearchInput] = useState(null) // end point select hota hai jaha pr aap ko jana hai 
  const [NextPrev, setNextPrev] = useState(null) // next prev btn dikhane ke liye 
  const [StartAndEndPart, setStartAndEndPart] = useState(false) // start end layout dikhane ke liye 
  const [DisplayStartPointResult, setDisplayStartPointResult] = useState(null) // search result dikhata hai start vala 
  const [DisplayEndPointResult, setDisplayEndPointResult] = useState(null) // serach result dikhata hai end vala
  const [selectShapData, setSelectShapData] = useState(null)  // store select shap data (zoom 3d store ke liye)
  const [shapZooomPosition, setShapZooomPosition] = useState(null) //position save
  const [jugaddotcom, setjugaddotcom] = useState(false)
  const [Device, setDevice] = useState(false)
  const [pinRef, setPinRef] = useState(null)
  const [css, setcss] = useState(null)
  const [pinArray, setpinArray] = useState([]) //show pin
  const [defaultPosition, setDefaultPosition] = useState(null)
  const [AdsData, setAdsData] = useState(null)
  const [pathAllPoint, setpathAllPoint] = useState([]) //path singal point for show icon
  const [floorRootPaths, setfloorRootPaths] = useState([]) //ek floor ke sabhi path isme store hai 
  const [ActiveFloor, setActiveFloor] = useState(0) // active floor
  const [CurrentRoots, setCurrentRoots] = useState(null) // current roots hai ye 
  const [MINIAPP, setMINIAPP] = useState(false)
  const [AllMallName, setAllMallName] = useState([
    { id: 1, name: "678694593190113", sName: 'elante' },
    { id: 2, name: '250668741424550', sName: "celebration" },
    { id: 3, name: '62958829632578', sName: "Whitefield" },
    { id: 4, name: '230326967629101', sName: "Koramangala" },
    { id: 5, name: '879167591707213', sName: "Seawoods" },
    { id: 6, name: '727124094807648', sName: "Hyderabad" },
    { id: 7, name: '745032076648953', sName: "Shantiniketan" },
    { id: 7, name: 'MECSR-event', sName: "MECSR-event" },
  ])
  window.path = path
  window.CurrentFloor = CurrentFloor
  window.nodePoint = nodePoint
  window.FloorImg = FloorImg

  let value = {
    MINIAPP, setMINIAPP,
    CurrentRoots, setCurrentRoots,
    ActiveFloor, setActiveFloor,
    floorRootPaths, setfloorRootPaths,
    AdsData, setAdsData,
    jugaddotcom, setjugaddotcom,
    css, setcss,
    Device, setDevice,
    AllMallName, setAllMallName,
    width, setwidth,
    height, setheight,
    nodePoint, setnodePoint,
    nodeLine, setnodeLine,
    CurrentFloor, setCurrentFloor,
    FloorImg, setFloorImg,
    finleSearch, setfinleSearch,
    selectPointA, setselectPointA,
    selectPointB, setselectPointB,
    PointType, setPointType,
    viewType, setViewType,
    mallType, setMallType,
    StapeByStape, setStapeByStape,
    path, setpath,
    w, setw,
    h, seth,
    StartSearchInput, setStartSearchInput,
    EndSearchInput, setEndSearchInput,
    NextPrev, setNextPrev,
    StartAndEndPart, setStartAndEndPart,
    DisplayStartPointResult, setDisplayStartPointResult,
    DisplayEndPointResult, setDisplayEndPointResult,
    selectShapData, setSelectShapData,
    shapZooomPosition, setShapZooomPosition,
    pinRef, setPinRef,
    pinArray, setpinArray,
    defaultPosition, setDefaultPosition,
    pathAllPoint, setpathAllPoint
  };
  return <GVarState.Provider value={value}>{children}</GVarState.Provider>;
}

export default Gstate;
